import React, { useEffect, useState, useContext } from "react";
import {
  Typography,
  Stack,
  Box,
  Button,
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  TextField,
  Grid,
  InputAdornment,
  Avatar,
  MenuItem,
  Select,
  FormControl,
} from "@mui/material";
import { Link } from "react-router-dom";
import { useQuery } from "@apollo/client";
//Icons
import SearchIcon from "@mui/icons-material/Search";

//Srcs
import "../Style/pagestyle.scss";
import CreateIcon from "../Assets/create-icon.svg";
import EmptyData from "../Components/Include/EmptyData";
import LoadingPage from "../Components/Include/LoadingPage";
import { AuthContext } from "../Context/AuthContext";
import { translateLauguage } from "../Function/Translate";
import FooterPagination from "../Components/Include/FooterPagination";
import CreateUser from "../Components/User/CreateUser";
import UserAction from "../Components/User/UserAction";
import { GET_USER_WITH_PAGINATION } from "../Schema/User";

export default function User() {
  // Change Language
  const { language } = useContext(AuthContext);
  const { t } = translateLauguage(language);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [keyword, setKeyword] = useState("");
  const [paginationData, setPaginationData] = useState();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(8);
  const [role, setRole] = useState("All");

  const { refetch } = useQuery(GET_USER_WITH_PAGINATION, {
    variables: {
      page: page,
      limit: limit,
      keyword: keyword,
      role: role,
    },
    onCompleted: ({ getAccountingUsersWithPagination }) => {
      setTableData(getAccountingUsersWithPagination?.data);
      setPaginationData(getAccountingUsersWithPagination?.paginator);
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  const handleLimit = (e) => {
    setLimit(e.target.value);
    setPage(1);
  };

  const handleSearch = (e) => {
    setPage(1);
    setKeyword(e.target.value);
  };

  useEffect(() => {
    refetch();
  }, [page, keyword, role]);

  useEffect(() => {
    if (tableData?.length !== 0) {
      let refetchData = tableData?.filter((d) => d?.role === null);
      if (refetchData?.length !== 0) {
        refetch();
      }
    }
  }, [tableData?.length]);

  // ======================= Resize width Screen ======================
  const [width, setWidth] = useState(window.innerWidth);
  const updateDimensions = () => {
    setWidth(window.innerWidth - 50);
  };
  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  return (
    <div className="page-container">
      <Stack direction="row" spacing={2} className="page-header">
        <Stack direction="column" justifyContent="center">
          <Box className="slash" />
        </Stack>

        <Stack direction="column" justifyContent="center">
          <Link className="page-link-title" to="/setting">
            <Typography className="page-title">{t("page_setting")}</Typography>
          </Link>
        </Stack>
        <Stack direction="column" justifyContent="center">
          <Typography className="slash-title">/</Typography>
        </Stack>
        <Stack direction="column" justifyContent="center">
          <Typography className="page-title">{t("page_user")}</Typography>
        </Stack>

        <Box sx={{ flexGrow: 1 }} />

        <Stack direction="row" spacing={0.6}>
          <Stack direction="column" justifyContent="center">
            <Link className="page-link-title" to="/">
              {t("page_dashboard")}
            </Link>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <Typography className="breadcrumbs-title">/</Typography>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <Typography className="breadcrumbs-title">
              {t("page_user")}
            </Typography>
          </Stack>
        </Stack>
      </Stack>

      <Box sx={{ marginTop: "30px" }}>
        <Grid container spacing={3}>
          <Grid item xs={6} md={4} lg={3}>
            <Typography className="search-head-title">
              {t("thead_search_name")}
            </Typography>

            <TextField
              placeholder={t("search")}
              size="small"
              className="search-field"
              onChange={handleSearch}
              InputProps={{
                startAdornment: (
                  <InputAdornment
                    position="start"
                    sx={{ mr: 1, color: "#0f81c2" }}
                  >
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={6} md={4} lg={3}>
            <Typography className="search-head-title">
              {t("thead_select_role")}
            </Typography>
            <FormControl className="select-role" fullWidth size="small">
              <Select value={role} onChange={(e) => setRole(e.target.value)}>
                <MenuItem value="All">All</MenuItem>
                <MenuItem value="AffairDirector">Affair director</MenuItem>
                <MenuItem value="HeadOffice">Headffice</MenuItem>
                <MenuItem value="AccountReceived">Account received</MenuItem>
                <MenuItem value="AccountPayable">Account payable</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={4} lg={6}>
            <Stack direction="row" justifyContent="right">
              <Button
                onClick={handleOpen}
                className="btn-create"
                startIcon={
                  <img src={CreateIcon} alt="CreateIcon" className="icon-add" />
                }
              >
                {t("create")}
              </Button>

              <CreateUser
                open={open}
                handleClose={handleClose}
                setRefetch={refetch}
              />
            </Stack>
          </Grid>
        </Grid>
      </Box>

      <Box className="body-container">
        <TableContainer sx={{ maxWidth: `${width}px` }}>
          <Table className="table" aria-label="simple table">
            <TableHead className="header-row ">
              <TableCell className="header-title-start">{t("no")}</TableCell>
              <TableCell className="header-title">
                {t("thead_username")}
              </TableCell>
              <TableCell className="header-title">{t("thead_role")}</TableCell>
              <TableCell className="header-title">{t("thead_email")}</TableCell>
              <TableCell className="header-title-end"></TableCell>
            </TableHead>
            {loading ? (
              <TableBody className="body">
                <TableRow className="body-row">
                  <TableCell
                    colSpan={6}
                    className="body-cell"
                    sx={{ bgcolor: "#fff" }}
                  >
                    <LoadingPage />
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <>
                {tableData?.length === 0 ? (
                  <TableBody className="body">
                    <TableRow className="body-row">
                      <TableCell colSpan={6} className="body-cell">
                        <EmptyData />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <>
                    <TableBody className="body">
                      {tableData?.map((row, index) => {
                        return (
                          <TableRow className="body-row" key={index}>
                            <TableCell className="body-cell-start">
                              {index + paginationData?.slNo}
                            </TableCell>
                            <TableCell className="body-cell">
                              <Stack direction="row" spacing={1.4}>
                                <Stack
                                  direction="column"
                                  justifyContent="center"
                                >
                                  <Avatar
                                    sx={{ width: 40, height: 40 }}
                                    alt={row?.first_name}
                                    src={row?.userProfile}
                                  />
                                </Stack>
                                <Stack
                                  direction="column"
                                  justifyContent="center"
                                >
                                  <Typography className="student-name">
                                    {row?.userName}
                                  </Typography>
                                </Stack>
                              </Stack>
                            </TableCell>
                            <TableCell className="body-cell">
                              {row?.role}
                            </TableCell>
                            <TableCell className="body-cell">
                              {row?.email}
                            </TableCell>

                            <TableCell className="body-cell-end" align="right">
                              <UserAction editData={row} setRefetch={refetch} />
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </>
                )}
              </>
            )}
          </Table>
        </TableContainer>

        {/* ==================== Pagination  ============================= */}
        <FooterPagination
          totalPages={paginationData?.totalPages}
          totalDocs={paginationData?.totalDocs}
          limit={limit}
          page={page}
          setPage={setPage}
          handleLimit={handleLimit}
          setLoading={setLoading}
        />
      </Box>
    </div>
  );
}
